import * as React from 'react';
import Box from "@mui/material/Box";
import {useEffect, useRef, useState} from "react";
import {BASE_URL} from "../../constants";
import {reportErrors} from "../../helpers";
import {Button, Divider, Grid, IconButton} from "@mui/material";
import InputField from "../../components/InputField";
import {Add, Delete, Edit} from "@mui/icons-material";
import ModalPage from "../../components/ModalPage";
import TableData from "../../components/TableData";
import AddEmployee from "./AddEmployee";
import {useNavigate} from "react-router-dom";
import UserDetails from "./UserDetails";
import Typography from "@mui/material/Typography";

export default function Employee(props) {
    const navigate = useNavigate();
    const modal = useRef();
    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [phone, setPhone] = useState();
    const [data, setData] = useState({total: 0, data: []});
    const [startDate, setStartDate] = useState();
    const [showProgress, setShowProgress] = useState(false);

    useEffect(() => {
        loadData();
    }, [name, phone, email]);
    const loadData = () => {
        let url = `${BASE_URL}api/system-users?data=data`;
        if (name) {
            url += `&name=${name}`;
        }

        if (email) {
            url += `&email=${email}`;
        }

        if (phone) {
            url += `&phone=${phone}`;
        }
        setShowProgress(true);
        window.axios
            .get(url)
            .then((response) => {
                setData(response.data.data)
                setShowProgress(false)
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };

    const submit = () => {
        console.log(startDate);
    }

    const updateCustomer = (data) => {
        let component = <AddEmployee loadData={loadData} modal={modal} data={data}/>;
        modal.current.show('User', component, 'small');
    }

    const addCustomerModal = () => {
        let component = <AddEmployee loadData={loadData} modal={modal}/>;
        modal.current.show('User', component, 'small');
    }

    const userDetails = (data) => {
        let component = <UserDetails loadData={loadData} modal={modal} employeeId={data?.userId}/>;
        modal.current.show('User', component, "60%");
    }

    return (
        <>
            <Box>
                <Grid container spacing={1} sx={{mb: 2}}>
                    <Grid item xs={12}><Typography variant="h5">User Management</Typography></Grid>
                    <Grid item xs={12}><Divider/></Grid>
                    <Grid item xs={3}><InputField placeholder="Full Name"
                                                  onChange={(value) => setName(value)}/></Grid>
                    <Grid item xs={3}><InputField placeholder="Phone"
                                                  onChange={(value) => setPhone(value)}/></Grid>
                    <Grid item xs={3}><InputField placeholder="Email"
                                                  onChange={(value) => setEmail(value)}/></Grid>
                    <Grid item xs={2}/>
                    <Grid item xs={1}>
                        <Button
                            startIcon={<Add/>}
                            disableElevation sx={{textTransform: "none"}}
                            fullWidth size="medium"
                            variant="contained" color="primary"
                            onClick={() => addCustomerModal()}>
                            Employee
                        </Button>
                    </Grid>
                    <Grid item xs={12}><Divider/></Grid>
                </Grid>
                <TableData
                    showProgres={showProgress}
                    url="customer/customer"
                    title="Users List"
                    columns={[
                        {
                            id: 'firstName',
                            label: 'First Name',
                            customerRender: true,
                            valueGetter: (item) => (<>{item.firstName}</>)
                        },
                        {
                            id: 'middleName',
                            label: 'Middle Name',
                            customerRender: true,
                            valueGetter: (item) => (<>{item.middleName}</>)
                        },
                        {
                            id: 'lastName',
                            label: 'Last Name',
                            customerRender: true,
                            valueGetter: (item) => (<>{item.lastName}</>)
                        },
                        {id: 'phone', label: 'Phone'},
                        {id: 'email', label: 'Email'},
                        {id: 'gender', label: 'Gender'},
                        {id: 'status', label: 'Status'},
                        {
                            id: 'action',
                            label: 'Action',
                            minWidth: "small",
                            disabled: true,
                            customerRender: true,
                            valueGetter: (item) => (
                                <IconButton size="small" onClick={() => updateCustomer(item)}><Edit/></IconButton>)
                        },
                    ]}
                    rows={data}
                    rowClick={true}
                    rowFunction={(item) => userDetails(item)}
                />
            </Box>
            <ModalPage ref={modal}/>
        </>
    );
}